<template>
  <div v-if="isMounted" class="whole-calendar">
    <WholeCalendarMonth
      v-if="d_mode == 'month'"
      :weekdays-name="d_weekdaysName"
      :weekday-numbers="d_weekdayNumbers"
      :locale="d_locale"
      :date-moment="d_dateMoment"
      :event-types="_eventTypes"
      :events="events"
      @date-change="$_handleDateChange($event)"
      @event-click="$_handleEventClick($event)"
    />
    <WholeCalendarEventList
      v-else-if="d_mode == 'eventList'"
      :locale="d_locale"
      :date-moment="d_dateMoment"
      :event-types="_eventTypes"
      :events="events"
      @date-change="$_handleDateChange($event)"
      @event-click="$_handleEventClick($event)"
    />
    <WholeCalendarGantt
      v-else-if="d_mode == 'gantt'"
      :gantt-items="ganttItems"
      :event-types="_eventTypes"
      :isLoading="isLoading"
      @event-click="$_handleEventClick($event)"
    />
  </div>
</template>
<script>
import moment from 'moment';
export default {
  props: {
    ganttItems: {
      type: Array,
      default: null,
    },
    weekdayNumbers: {
      type: Array,
      default() {
        return [0, 1, 2, 3, 4, 5, 6];
      },
    },
    mode: {
      type: String,
      default: 'month',
      validator(value) {
        return ['month', 'week', 'day', 'eventList', 'gantt'].indexOf(value) !== -1;
      },
    },
    locale: {
      type: String,
      default: 'zh_tw',
    },
    date: {
      validator(value) {
        return moment(value).isValid();
      },
    },
    events: {
      type: Array,
      default() {
        return [];
      },
    },
    eventTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMounted: false,
      allWeekdaysNumbers: [0, 1, 2, 3, 4, 5, 6],
      d_mode: null,
      d_weekdayNumbers: null,
      d_weekdaysName: [
        this.$t('日'),
        this.$t('一'),
        this.$t('二'),
        this.$t('三'),
        this.$t('四'),
        this.$t('五'),
        this.$t('六'),
      ],
      d_locale: null,
      d_dateMoment: null,
    };
  },
  computed: {
    _eventTypes() {
      const _eventTypes = [];
      this.eventTypes.forEach(eventType => {
        _eventTypes.push({
          name: eventType.name,
          iconImage: eventType.iconImage,
          text: eventType.text,
          icon: eventType.icon,
        });
      });
      let needOther = 0;
      this.events.forEach(event => {
        if (!event.eventType) {
          needOther = 1;
        }
      });
      if (needOther) {
        _eventTypes.push({
          name: '__other',
          text: this.$t('其他'),
        });
      }
      return _eventTypes;
    },
  },
  watch: {
    mode: {
      handler() {
        this.d_mode = this.mode;
      },
    },
    date: {
      handler() {
        this.d_dateMoment = moment(this.date).isValid() ? moment(this.date) : moment();
      },
    },
  },
  mounted() {
    this.$_setDataFromProps();
    this.isMounted = true;
  },
  methods: {
    $_handleEventClick($event) {
      this.$emit('event-click', $event);
    },
    $_handleDateChange($event) {
      this.d_dateMoment = $event;
      this.$emit('update-date', $event);
    },
    $_getDataWeekdayNumbers() {
      const dataWeekdayNumbers = [];
      this.allWeekdaysNumbers.forEach(allWeekdaysNumber => {
        if (this.weekdayNumbers.includes(allWeekdaysNumber)) {
          dataWeekdayNumbers.push(allWeekdaysNumber);
        }
      });
      return dataWeekdayNumbers;
    },
    $_setDataFromProps() {
      this.d_mode = this.mode;
      this.d_weekdayNumbers = this.$_getDataWeekdayNumbers();
      this.d_locale = this.$i18n.locale || 'tw';
      this.d_dateMoment = moment(this.date).isValid() ? moment(this.date) : moment();
    },
  },
};
</script>
